import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from './modules/auth/auth';
import { ltrs } from './modules/ltrs/ltrs';

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',

    modules: {
        auth,
        ltrs,
    },
});

export default store;
